import React from 'react';
import styles from './Signature.module.scss';
import SignatureCanvas from 'react-signature-canvas-react17-compatible';

import { Container, Row, Col, Button } from 'react-bootstrap';

export type SignatureProps = {
  title: string
  reference?: any;
  setSigTouched?: any;
  supervisor?: false | true;
  required?: false | true;
  name?: string;
};

const Signature = ({ title, name, reference, setSigTouched, supervisor, required}: SignatureProps) => {
  const clear = () => {
    reference.current.clear();
    setSigTouched(false);
  }

  return (
    <Container className={supervisor ? styles.SignatureSuperVisor : styles.Signature} data-testid="Signature">
      <Row>
        <Col>
          <label>{title}{required ? <span style={{ color: 'red' }}>*</span> : null}</label>
          <SignatureCanvas
            name={name}
            canvasProps={{ className: styles.SignatureBox }}
            ref={reference}
            clearOnResize={false}
            onEnd={() => {
              setSigTouched(true);
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles.SignatureClear}>
            <Button variant="danger" size={'sm'} onClick={clear}>
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Signature;
